var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "how-earn-root",
      class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
    },
    [
      _c("div", { staticClass: "how-title" }, [
        _vm._v(_vm._s(_vm.$t("lang.newInvite.k005"))),
      ]),
      _c("div", { staticClass: "how-block right-read" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("lang.newInvite.k006")))]),
        _c("div", { staticClass: "content-wrap" }, [
          _c(
            "div",
            { staticClass: "invite-btn", on: { click: _vm.handleClick } },
            [_vm._v(_vm._s(_vm.$t("lang.newInvite.k001")))]
          ),
        ]),
      ]),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "how-block right-read" },
        [
          _vm.packageName === "kiko"
            ? _c("MyPLabel", {
                attrs: {
                  str: _vm.$t("lang.newInvite.k007"),
                  numsOption: [
                    {
                      value: _vm.info.maxInviteBeanReward || "",
                      style: "color:#ff8a33",
                    },
                  ],
                },
              })
            : _c("MyPLabel", {
                attrs: {
                  str: _vm.$t("lang.newInvite.k007"),
                  numsOption: [
                    {
                      value: _vm.info.maxInviteBeanReward || "",
                      style: "color:#a338fc",
                    },
                  ],
                },
              }),
          _c("div", { staticClass: "content-wrap" }, [
            _c("div", { staticClass: "step-tips1" }, [
              _vm._m(1),
              _vm._m(2),
              _c("div", { staticClass: "tips-item" }, [
                _vm.packageName === "kiko"
                  ? _c("img", {
                      attrs: {
                        src: require("../images/status-step2-kiko.png"),
                        alt: "",
                      },
                    })
                  : _c("img", {
                      attrs: {
                        src: require("../images/status-step2.png"),
                        alt: "",
                      },
                    }),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._m(3),
      _c(
        "div",
        { staticClass: "how-block right-read" },
        [
          _c("MyPLabel", {
            attrs: {
              str: _vm.$t("lang.newInvite.k008"),
              numsOption: [
                {
                  value: `${_vm.info.maxShareRate || ""}%`,
                  style: "color:#a338fc",
                },
              ],
            },
          }),
          _c("div", { staticClass: "content-wrap" }, [
            _c("div", { staticClass: "step-tips1" }, [
              _c("div", { staticClass: "tips-item" }, [
                _vm.packageName === "kiko"
                  ? _c("img", {
                      attrs: {
                        src: require("../images/status-step2-kiko.png"),
                        alt: "",
                      },
                    })
                  : _c("img", {
                      attrs: {
                        src: require("../images/status-step2.png"),
                        alt: "",
                      },
                    }),
              ]),
              _vm._m(4),
              _c("div", { staticClass: "tips-item" }, [
                _vm.packageName === "kiko"
                  ? _c("img", {
                      attrs: {
                        src: require("../images/msg-kiko.png"),
                        alt: "",
                      },
                    })
                  : _c("img", {
                      attrs: { src: require("../images/msg.png"), alt: "" },
                    }),
              ]),
              _vm._m(5),
              _vm._m(6),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "connect-arrow" }, [
      _c("img", {
        attrs: { src: require("../images/double-down.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tips-item" }, [
      _c("img", {
        attrs: { src: require("../images/status-step1.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tips-item add-icon" }, [
      _c("img", { attrs: { src: require("../images/add.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "connect-arrow" }, [
      _c("img", {
        attrs: { src: require("../images/double-down.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tips-item add-icon" }, [
      _c("img", { attrs: { src: require("../images/add.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tips-item add-icon" }, [
      _c("img", { attrs: { src: require("../images/add.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tips-item" }, [
      _c("img", { attrs: { src: require("../images/gift.png"), alt: "" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }